module.exports = __webpack_public_path__ + "media/images/logo--warranty--white-d9cc428c53e8da3fdab1bdb025f3626e.svg";